import { get, map } from "lodash";
import React from "react";

import { getAttributeName } from "../../utils/attributes";
import FormSection from "../Common/FormSection";

export const CreateNewUser = (props) => {
  const { language, lov, values, handleChange, errors, valid, isEditing } =
    props;

  return (
    <>
      {!isEditing && (
        <>
          <FormSection
            formValue={[get(values, ["firstname"]) || ""]}
            setFormValue={handleChange}
            title="firstName"
            id="firstname"
            options={{
              required: true,
              errorMsg: errors["firstname"],
              redBorder: !get(valid, ["firstname"]),
            }}
          />
          <FormSection
            formValue={[get(values, ["lastname"]) || ""]}
            setFormValue={handleChange}
            title="lastName"
            id="lastname"
            options={{
              required: true,
              errorMsg: errors["lastname"],
              redBorder: !get(valid, ["lastname"]),
            }}
          />
          <FormSection
            formValue={[get(values, ["username"]) || ""]}
            setFormValue={handleChange}
            title="username"
            id="username"
            options={{
              required: true,
              errorMsg: errors["username"],
              redBorder: !get(valid, ["username"]),
            }}
          />
          <FormSection
            formValue={[get(values, ["email"]) || ""]}
            setFormValue={handleChange}
            title="email"
            id="email"
            options={{
              required: true,
              errorMsg: errors["email"],
              redBorder: !get(valid, ["email"]),
            }}
          />
        </>
      )}
      <FormSection
        formValue={get(values, ["roles"]) || []}
        setFormValue={handleChange}
        title="roles"
        id="roles"
        type="select"
        options={{
          multipleSelect: true,
          required: true,
          redBorder: !get(valid, ["roles"]),
          errorMsg: errors["roles"],
          options: map(get(lov, ["roles"]), (t) => ({
            id: t.id,
            name: t[`name_${language}`],
          })),
        }}
      />
      {!isEditing && (
        <>
          <FormSection
            formValue={[get(values, ["tag"]) || ""]}
            setFormValue={handleChange}
            title="tag"
            id="tag"
            type="select"
            options={{
              required: true,
              redBorder: !get(valid, ["tag"]),
              errorMsg: errors["tag"],
              options: map(get(lov, ["tags"]), (t) => ({
                id: t.id,
                name: t[`name_${language}`],
              })),
            }}
          />
          <FormSection
            formValue={[get(values, [35]) || ""]}
            setFormValue={handleChange}
            title2={getAttributeName(35)}
            id={35}
            type="select"
            options={{
              required: true,
              errorMsg: errors[35],
              redBorder: !get(valid, [35]),
              options: map(get(lov, [35]), (t) => ({
                id: t.id,
                name: t[`name_${language}`],
              })),
            }}
          />
        </>
      )}
    </>
  );
};
